import { SxProps, Theme } from '@mui/system';

const size = 40;
const notifSize = 16;

export default {
  container: {
    minWidth: 80,
    backgroundColor: 'secondary.main',
    borderRight: '1px solid',
    borderColor: 'common.border',
    paddingTop: '21px',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconContainer: {
    flexDirection: 'column',
    borderRadius: 0,
    width: '100%',
    marginBottom: '24px',
  },
  dot: {
    height: notifSize,
    width: notifSize,
    borderRadius: notifSize / 2,
    position: 'absolute',
    backgroundColor: 'common.counterRed',
    right: -5,
    top: -5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 11,
    fontWeight: '500',
    color: 'secondary.main',
  },
  icon: {
    position: 'relative',
    height: size,
    width: size,
    borderRadius: size / 2,
    backgroundColor: 'common.lightGreen',
  },
  label: {
    fontSize: 10,
    fontWeight: '500',
    color: 'common.grey850',
  },
  isActive: {
    borderLeft: '3px solid',
  },
  activeLabel: {
    color: 'primary.main',

  },
} satisfies Record<string, SxProps<Theme>>;
